import { LoadingSpinner } from './LoadingSpinner';

export function PageLoadingFallback() {
  return (
    <div className="py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <LoadingSpinner />
      </div>
    </div>
  );
}
